export type SolutionDownload = {
  label: string;
  platform: string;
  url?: string;
  note?: string;
};

export type Solution = {
  slug: string;
  name: string;
  tagline: string;
  summary: string;
  description: string;
  image?: string;
  accent: string;
  bg: string;
  text: string;
  repositoryUrl: string;
  releaseUrl?: string;
  webUrl?: string;
  latestRelease?: string;
  highlights: string[];
  downloads: SolutionDownload[];
};

export const SOLUTIONS: Solution[] = [
  {
    slug: 'hin',
    name: 'Hin',
    tagline: 'Work OS tout-en-un',
    summary: 'Une plateforme unifiée pour gérer projets, équipes, ventes, recrutement, design, lancements et support.',
    description:
      "Hin remplace la galaxie d'outils SaaS par un espace de travail centralisé: tâches, CRM, documents, fichiers, support, recrutement, automatisations et dashboards métier.",
    image: '/solutions/hin.png',
    accent: 'from-red-600 to-red-800',
    bg: 'bg-red-50',
    text: 'text-red-700',
    repositoryUrl: 'https://github.com/nahim-salami/hin',
    webUrl: 'https://hin.ahime.net/',
    highlights: ['Workspaces, spaces, listes et tâches', 'CRM, recrutement, support et documents', 'RBAC, notifications et audit log', 'Web, desktop et mobile prévus'],
    downloads: [
      { label: 'Ouvrir Hin Web', platform: 'Web', url: 'https://hin.ahime.net/' },
      { label: 'Windows', platform: 'Windows', note: 'Release publique à venir' },
      { label: 'macOS', platform: 'macOS', note: 'Release publique à venir' },
      { label: 'Linux', platform: 'Linux', note: 'Release publique à venir' },
      { label: 'Android', platform: 'Android', note: 'Release publique à venir' },
      { label: 'iOS', platform: 'iOS', note: 'Release publique à venir' },
    ],
  },
  {
    slug: 'su',
    name: 'Su POS',
    tagline: 'Caisse, stock et facturation e-MECeF',
    summary: 'Solution POS/ERP multiplateforme pour boutiques, réseaux multi-magasins et facturation normalisée au Bénin.',
    description:
      'Su aide les commerçants à encaisser, gérer le stock, piloter plusieurs boutiques et synchroniser les données en offline-first avec conformité e-MECeF.',
    image: '/solutions/su.png',
    accent: 'from-red-600 to-red-800',
    bg: 'bg-red-50',
    text: 'text-red-700',
    repositoryUrl: 'https://github.com/nahim-salami/su',
    releaseUrl: 'https://github.com/nahim-salami/su-pos/releases/tag/v0.1.0',
    webUrl: 'https://su.ahime.net/',
    latestRelease: 'v0.1.0',
    highlights: ['Caisse tactile offline-first', 'Gestion stock, achats, clients et ventes', 'Comptabilité OHADA et reporting', 'Téléchargements Windows, Android, macOS et Linux'],
    downloads: [
      { label: 'Windows installer', platform: 'Windows', url: 'https://github.com/nahim-salami/su-pos/releases/download/v0.1.0/su-pos-setup-windows.exe' },
      { label: 'Android APK', platform: 'Android', url: 'https://github.com/nahim-salami/su-pos/releases/download/v0.1.0/su-pos-android.apk' },
      { label: 'macOS DMG', platform: 'macOS', url: 'https://github.com/nahim-salami/su-pos/releases/download/v0.1.0/su-pos-macos.dmg' },
      { label: 'Linux DEB', platform: 'Linux', url: 'https://github.com/nahim-salami/su-pos/releases/download/v0.1.0/su-pos-linux.deb' },
      { label: 'Su Web', platform: 'Web', url: 'https://app.su.ahime.net' },
    ],
  },
  {
    slug: 'wifitche',
    name: 'WiFiTche',
    tagline: 'Vente de Wi-Fi via MikroTik',
    summary: 'Plateforme pour vendre des accès Wi-Fi, gérer les paiements et provisionner les comptes hotspot MikroTik.',
    description:
      'WiFiTche connecte les clients, les administrateurs Wi-Fi et le superadmin autour des routeurs MikroTik, avec paiements FedaPay, wallets, support et provisioning local.',
    accent: 'from-red-600 to-red-800',
    bg: 'bg-red-50',
    text: 'text-red-700',
    repositoryUrl: 'https://github.com/nahim-salami/wifitche',
    releaseUrl: 'https://github.com/nahim-salami/wifitche-releases/releases/tag/latest',
    webUrl: 'https://wifitche-api.vercel.app',
    latestRelease: 'latest',
    highlights: ['Apps client, admin et superadmin', 'Provisioning hotspot MikroTik local', 'Paiements et retraits via FedaPay', 'APK Android et bundles Windows publics'],
    downloads: [
      { label: 'Client Android', platform: 'Android', url: 'https://github.com/nahim-salami/wifitche-releases/releases/download/latest/wifitche-client.apk' },
      { label: 'Client Windows', platform: 'Windows', url: 'https://github.com/nahim-salami/wifitche-releases/releases/download/latest/wifitche-client-windows.zip' },
      { label: 'Admin Android', platform: 'Android', url: 'https://github.com/nahim-salami/wifitche-releases/releases/download/latest/wifitche-admin.apk' },
      { label: 'Admin Windows', platform: 'Windows', url: 'https://github.com/nahim-salami/wifitche-releases/releases/download/latest/wifitche-admin-windows.zip' },
      { label: 'Superadmin Android', platform: 'Android', url: 'https://github.com/nahim-salami/wifitche-releases/releases/download/latest/wifitche-superadmin.apk' },
      { label: 'Superadmin Windows', platform: 'Windows', url: 'https://github.com/nahim-salami/wifitche-releases/releases/download/latest/wifitche-superadmin-windows.zip' },
    ],
  },
  {
    slug: 'ajo',
    name: 'Ajo',
    tagline: 'Épargne à objectifs avec fonds gelés',
    summary: "Application mobile d'épargne qui verrouille les fonds jusqu'à la date de déblocage choisie.",
    description:
      "Ajo permet de créer un objectif, confirmer une échéance, déposer via paiement mobile et retirer à maturité, avec frais appliqués uniquement au retrait.",
    accent: 'from-red-600 to-red-800',
    bg: 'bg-red-50',
    text: 'text-red-700',
    repositoryUrl: 'https://github.com/nahim-salami/ajo',
    releaseUrl: 'https://github.com/nahim-salami/ajo/releases/tag/build-38',
    webUrl: 'https://ajo-self.vercel.app',
    latestRelease: 'build-38',
    highlights: ['Objectifs avec date de déblocage', 'Fonds verrouillés jusqu’à maturité', 'Paiements FedaPay et backend serverless', 'APK Android disponible'],
    downloads: [
      { label: 'Android APK', platform: 'Android', url: 'https://github.com/nahim-salami/ajo/releases/download/build-38/app-release.apk' },
      { label: 'Ouvrir Ajo Web', platform: 'Web', url: 'https://ajo-self.vercel.app' },
      { label: 'iOS', platform: 'iOS', note: 'Release publique à venir' },
    ],
  },
];

export function getSolution(slug: string | undefined) {
  return SOLUTIONS.find((solution) => solution.slug === slug);
}
